/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemSlaContractDto } from './OemSlaContractDto';
import {
    OemSlaContractDtoFromJSON,
    OemSlaContractDtoFromJSONTyped,
    OemSlaContractDtoToJSON,
    OemSlaContractDtoToJSONTyped,
} from './OemSlaContractDto';

/**
 * 
 * @export
 * @interface UpdateOemContractResponseDto
 */
export interface UpdateOemContractResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOemContractResponseDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOemContractResponseDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOemContractResponseDto
     */
    partnerName: string;
    /**
     * 
     * @type {OemSlaContractDto}
     * @memberof UpdateOemContractResponseDto
     */
    slaContract?: OemSlaContractDto | null;
}

/**
 * Check if a given object implements the UpdateOemContractResponseDto interface.
 */
export function instanceOfUpdateOemContractResponseDto(value: object): value is UpdateOemContractResponseDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    return true;
}

export function UpdateOemContractResponseDtoFromJSON(json: any): UpdateOemContractResponseDto {
    return UpdateOemContractResponseDtoFromJSONTyped(json, false);
}

export function UpdateOemContractResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOemContractResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'partnerOrgId': json['partnerOrgId'],
        'partnerName': json['partnerName'],
        'slaContract': json['slaContract'] == null ? undefined : OemSlaContractDtoFromJSON(json['slaContract']),
    };
}

export function UpdateOemContractResponseDtoToJSON(json: any): UpdateOemContractResponseDto {
    return UpdateOemContractResponseDtoToJSONTyped(json, false);
}

export function UpdateOemContractResponseDtoToJSONTyped(value?: UpdateOemContractResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'slaContract': OemSlaContractDtoToJSON(value['slaContract']),
    };
}

